import { ToggleSwitchProps } from "../../../common/types";

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  id,
  checked,
  onChange,
  labelYes = "YES",
  labelNo = "NO",
  disabled = false,
  overrideLabelNoColor,
  overrideLabelYesColor,
}) => {
  const toggle = () => {
    if (!disabled) onChange(!checked);
  };
  const buttonColor = disabled
    ? checked
      ? "bg-green-300"
      : "bg-gray-200"
    : checked
    ? "bg-green-500"
    : "bg-gray-300";

  const baseLabelNoColor = disabled
    ? "text-gray-400"
    : !checked
    ? "text-gray-700"
    : "text-gray-400";
  const baseLabelYesColor = disabled
    ? checked
      ? "text-green-400"
      : "text-gray-400"
    : checked
    ? "text-green-600"
    : "text-gray-400";

  const finalLabelNoColor = overrideLabelNoColor || baseLabelNoColor;
  const finalLabelYesColor = overrideLabelYesColor || baseLabelYesColor;

  return (
    <div className="flex items-center">
      <span className={`mr-2 text-base font-medium ${finalLabelNoColor}`}>
        {labelNo}
      </span>
      <button
        type="button"
        id={id}
        onClick={toggle}
        disabled={disabled}
        className={`${buttonColor} 
        relative inline-flex items-center h-6 w-11 rounded-full transition-colors 
        focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-blue-500
        ${disabled ? "cursor-not-allowed" : "cursor-pointer"}`}
        role="switch"
        aria-checked={checked}
      >
        <span
          className={`${
            checked ? "translate-x-6" : "translate-x-1"
          } inline-block w-4 h-4 transform bg-white rounded-full transition-transform`}
        />
      </button>
      <span className={`ml-2 text-base font-medium ${finalLabelYesColor}`}>
        {labelYes}
      </span>
    </div>
  );
};

export default ToggleSwitch;
